import React from 'react';
import { isSoundEnabled, setSoundEnabled } from '../../soundEngine';
import { Volume2, VolumeX } from 'lucide-react';

export default function SoundToggle({ className = '' }) {
  const [enabled, setEnabled] = React.useState(isSoundEnabled());

  const toggle = () => {
    const next = !enabled;
    setEnabled(next);
    setSoundEnabled(next);
  };

  return (
    <button className={`sound-toggle ${className}`} onClick={toggle} aria-label={enabled ? 'Mute' : 'Unmute'} data-testid="sound-toggle">
      {enabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
    </button>
  );
}
